import {
    Order,
    ProductSummary
} from './Order';
import {Product} from './Product';
import {Documents} from './Documents';
import {CaseAddresses} from './caseAddresses';
import {Document} from '../authorise/models/document';
import {
    EaCase,
    EaPerson
} from './EstateAdmin';
import {Line} from './Line';
import {CaseAddress2} from './rest-classes/Case';
import {CaseDictionary} from './rest-classes/Order';

export class Case { // implements ICase
    caseUser: caseUser;
    datecreated: Date;
    modifiedOn: Date;
    orders?: Order[];
    lines?: Line[];
    drafts?: Draft[];
    caseaddressid: number;
    caseDocuments: Documents[];
    productSummary: ProductSummary;
    caseFileId?: number;
    caseReference: string;
    CaseDocuments: Document[];
    status?: CaseStatus;
    address: CaseAddresses;
    caseaddresses: CaseAddresses[];
    caseAddress: CaseAddress2[];
    Token: string;
    Reference: string;
    CaseAdd: boolean = false;
    CaseTypeId?: number;
    eaCase?: EaCase;
    dataSubject?: EaPerson;
    mattertype: string;
    mattertypeid: number;
    matterTypeId?: number;
    caseDictionary: CaseDictionary[];

    constructor(_caseReference: string, _date: Date, _lines: Line[],
                _orders: Order[], _status: CaseStatus, _drafts: Draft[], _caseAddresses: CaseAddresses[]) {
        this.caseReference = _caseReference;
        this.datecreated = _date;
        this.orders = _orders;
        this.status = _status;
        this.drafts = _drafts;
        this.caseaddressid = 0;
        this.caseaddresses = _caseAddresses;
        this.lines = _lines;
        this.address = new CaseAddresses('', '', '', '', 0, 0, '', '', '', '', '', '', '', '', '', 0, 0);
    }
}

export enum CaseStatus {
    'Incomplete',
    'Complete'
}

export class Draft {
    id: number;
    products: Product[];
}

export class caseUser {
    firstName: string;
    lastName: string;
    userName: string;
}
